import type { RefObject } from 'react'
import React, { useEffect, useState } from 'react'
import './insider-dots.scss'
import type Slider from 'react-slick'

interface Props {
  length: number                
  currentSlider: number        
  maxVisibleIndicators?: number 
  refSlider: RefObject<Slider>
  colorDotsActive?: string
  isMobile?: boolean | null
  itemsPerPage?: number
  backgroundDotsActive?: string
  backgroundDotsInactive?: string
}

const InsiderDots: React.FC<Props> = ({
  length,
  currentSlider,
  maxVisibleIndicators = 6,   
  refSlider,
  itemsPerPage = 1,
  backgroundDotsActive = '#737373',
  backgroundDotsInactive = '#d2d2d2',
}) => {
  const [visibleIndices, setVisibleIndices] = useState<number[]>([])

  useEffect(() => {
    const totalPages = Math.ceil(length / itemsPerPage)
    if (totalPages <= maxVisibleIndicators) {
      setVisibleIndices(Array.from({ length: totalPages }, (_, k) => k))
      return
    }

    const half = Math.floor(maxVisibleIndicators / 2)
    let start = Math.max(0, currentSlider - half)
    let end = start + maxVisibleIndicators - 1

    if (end > totalPages - 1) {
      end = totalPages - 1
      start = end - (maxVisibleIndicators - 1)
    }
    setVisibleIndices(
      Array.from({ length: maxVisibleIndicators }, (_, i) => start + i)
    )
  }, [length, currentSlider, itemsPerPage, maxVisibleIndicators])

  return (
    <div className="indicators-wrapper">
      {visibleIndices.map((page) => {
        const isActive = page === currentSlider
        return (
          <button
            key={page}
            onClick={() =>
              refSlider.current?.slickGoTo(page * itemsPerPage)
            }
          >
            <span
              className={isActive ? 'active' : ''}
              style={{
                backgroundColor: isActive
                  ? backgroundDotsActive
                  : backgroundDotsInactive,
              }}
            />
          </button>
        )
      })}
    </div>
  )
}
export default InsiderDots
